/**
 * @module events/types/readyStateChange
 */

/**
 * @type {string}
 */
export default 'readystatechange'
